import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDaclQdds70BltZnNy9QpkB2A9TrnpWtr0",
  authDomain: "beiraboladasmz.firebaseapp.com",
  projectId: "beiraboladasmz",
  storageBucket: "beiraboladasmz.appspot.com",
  messagingSenderId: "788457765118",
  appId: "1:788457765118:web:e3678d5c2b25c1b9368daf",
  measurementId: "G-1VBS1KPMBK",
};


const app = initializeApp(firebaseConfig);

const analytics = getAnalytics(app);
const firestore = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export  {firestore, auth, storage}